import { useAPI } from '@/api/api';

export const useGetLoginSpecialActivityData = () => {
  const { data, error, isLoading, revalidate } = useAPI<any, any>(
    {
      path: '/api/index/loginSpecialActivity',
      type: 'get',
      needLogin: true,
    },
    null,
    {
      revalidateOnMount: true,
    }
  );
  return { data, error, isLoading, revalidate };
};
